import React, {useState} from 'react';
import { useParams } from "react-router-dom";
import Loader from '../../components/Loader';
import { useUser, isAdmin, isManager, isAgent } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import {useFirestoreCollection} from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import AddItem from '../actions/AddItem';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import ToggleActivationLink from '../actions/ToggleActivationLink';

const Sites = () => {

  //contexte de l'utilisateur connecté
  const user = useUser();
  const { client_id } = useParams(); // Capture l'ID du client depuis l'URL

  const collectionPath = (isManager(user.user) || isAgent(user.user)) ? `utilisateurs/${user.user.user.uid}/sites` : `clients/${client_id}/sites`; 

  const { data: sites, loader } = useFirestoreCollection(collectionPath);
  const [ajoutSite, popupAjoutSite] = useState(false);



  const columns = [
    { header: 'Nom', render: (site) => site.nom },
    { header: 'Adresse', render: (site) => site.adresse },
    { header: 'Date de création', render: (site) => dateFromTimestampToString(site.dateCreation.seconds) }
  ];


    {/* header: 'Active', render: (site) => (site.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (site) => (<ToggleActivationLink collection={`clients/${client_id}/sites`} item={site} />)*/}

  return (
    <div>

      {isAdmin(user.user) ? (
        <a href="#" onClick={() => popupAjoutSite(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Ajouter un site"} loading={false} />
        </a>
      ) : null }

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={sites} 
          columns={columns} 
          onRowClick={(site) => window.location.href = `/client/${client_id}/site/${site.id}`}
        />
      )}

      {ajoutSite ? (
        <AddItem
          onClose={() => popupAjoutSite(false)}
          collectionPath={`clients/${client_id}/sites`}
          title="Ajouter un site"
          fields={[
            { name: "nom", label: "Nom du site", type: "text" },
            { name: "adresse", label: "Adresse du site", type: "text" },
          ]}
        />
      ) : null }
    </div>
  );
};

export default Sites;
